/**
 * Onboarding setup state (BLU-1376, Phase 95).
 *
 * The vocabulary the server stores for an org's setup progress:
 *
 * - `SETUP_STEP_IDS`: every onboarding wizard step id, in the same order as the
 *   frontend `ALL_STEP_IDS`. `org_setup_steps.step_id` holds one of these; the
 *   list lives here, not in SQL, so adding a step never needs a migration.
 *   `inviteTeam` is the optional step (Mark as done only, never counted
 *   toward finishing setup). `customFiles` ("How do your custom files
 *   arrive?", BLU-1399) is appended last so existing ids keep their places;
 *   the walk order lives in the frontend step lists.
 * - `SETUP_STEP_STATES`: the flags an operator can set on a step (Mark as done,
 *   Skip). No row in `org_setup_steps` means not set.
 * - `PRINT_MODES`: the answer to "How do you print?" stored on
 *   `organizations.print_mode`. `client` = a 3PL prints for the org, `self` =
 *   the org prints on its own floor. Mirrors the DB CHECK.
 *
 * PURE: constants and types only.
 */
export const SETUP_STEP_IDS = [
    'shopify',
    'claim',
    'syncTag',
    'typeKinds',
    'codeTables',
    'metafields',
    'sync',
    'colourAliases',
    'ripRouting',
    'testOrder',
    'blankProducts',
    'blankInventory',
    'inviteTeam',
    'customFiles',
];
export const SETUP_STEP_STATES = ['done', 'skipped'];
export const PRINT_MODES = ['client', 'self'];
/** True when `value` is one of `PRINT_MODES` (narrows unknown DB / input values). */
export function isPrintMode(value) {
    return typeof value === 'string' && PRINT_MODES.includes(value);
}
